import BasicCode from "!!raw-loader!./radiobuttons/Basic.tsx";
import GroupCode from "!!raw-loader!./radiobuttons/Group.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import Basic from "./radiobuttons/Basic";
import Group from "./radiobuttons/Group";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Basic", BasicCode, Basic, "For single radio button that can toggle, use the onClick event handler."),
		paneComponent("Group", GroupCode, Group, "For a radio button group, use the onChange event handler."),
	];

	return (
		<Pane
			components={components}
			imports='import {Radio} from "designSystem/index";'
			muiApi="radio"
			muiComponent="radio-buttons"
			{...props}
		/>
	);
};